<div class="row" *ngIf="isComercial">
  <div class="col-lg col-md col-xs col-xl col-sm w-100">
    <mat-card class="mat-elevation-z8 w-100">
      <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
        <div class="row">
          <div class="col-lg col-md col-xs col-xl col-sm">
            <p class="tituloLeft">{{ step }}</p>
          </div>
          <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
            <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
              *ngIf="!collapseCard"></i>
            <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
              *ngIf="collapseCard"></i>
          </div>
        </div>
        <mat-card-content *ngIf="!collapseCard">
          <div class="row pt-3">
            <div class="col-6 pt-3">
              <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                floatLabel="{{ formFieldFloatLabel }}">
                <mat-label class="InputLabelColor">Site Beneficiamento</mat-label>
                <mat-select #txtMotRepr formControlName="site" disableCenteringOption disabled class="InputBlockColor">
                  <input matInput type="text" class="form-control filterTxt" placeholder="Pesquisar por..."
                    (keyup)="createFilterSite($event.target.value)" />
                  <mat-option *ngFor="let item of listSite" [value]="item.initials">
                    {{ item.initials | uppercase }}
                  </mat-option>
                </mat-select>
                <i matSuffix class="{{ iconDisableField }}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{
                  hintCalc
                }}</mat-hint>
                <mat-error>
                  {{ hasErrorFormControl(formulario.controls.site) }}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-6 pt-3">
              <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                floatLabel="{{ formFieldFloatLabel }}">
                <mat-label class="InputLabelColor">{{
                  hintSafraLabel
                }}</mat-label>
                <input matInput id="txtSafra" #txtSafra maxlength="8" formControlName="safra"
                  class="InputUnblockColor" />
                <i matSuffix class="{{ iconEnableField }}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{ hintSafra }}
                </mat-hint>
                <mat-hint align="end">{{ txtSafra.value.length }} / 8</mat-hint>
                <mat-error>{{
                  hasErrorFormControl(formulario.controls.safra)
                }}</mat-error>
              </mat-form-field>
            </div>

            <!-- Linha 2 -->

            <div class="col-6 pt-3">
              <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                floatLabel="{{ formFieldFloatLabel }}">
                <mat-label class="InputLabelColor">Data</mat-label>
                <input matInput id="txtData" #txtData maxlength="10" mask="d0/M0/0000" formControlName="data" />
                <i matSuffix class="{{ iconEnableField }}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{
                  hintDate
                }}</mat-hint>
                <mat-hint align="end">{{ txtData.value.length }} / 10</mat-hint>
                <mat-error>{{ hasErrorFormControl(formulario.controls.data) }}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-6 pt-3">
              <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                floatLabel="{{ formFieldFloatLabel }}">
                <mat-label class="InputLabelColor">Hora</mat-label>
                <input matInput id="txtHora" #txtHora maxlength="5" mask="Hh:m0" formControlName="hora" />
                <i matSuffix class="{{ iconEnableField }}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{
                  hintHour
                }}</mat-hint>
                <mat-hint align="end">{{ txtHora.value.length }} / 5</mat-hint>
                <mat-error>{{ hasErrorFormControl(formulario.controls.hora) }}
                </mat-error>
              </mat-form-field>
            </div>

            <div class="col-6 pt-3">
              <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                floatLabel="{{ formFieldFloatLabel }}">
                <mat-label class="InputLabelColor">Número Controle</mat-label>
                <input matInput id="txtNumContrl" #txtNumContrl maxlength="10" formControlName="numero_controle"
                  currencyMask [options]="{ thousands: '.', decimal: ',', precision: 0 }" readonly
                  class="InputBlockColor" />
                <i matSuffix class="{{ iconDisableField }}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{ hintControle }}
                </mat-hint>
                <mat-hint align="end">{{ txtNumContrl.value.length }} / 10</mat-hint>
                <mat-error>{{
                  hasErrorFormControl(formulario.controls.numero_controle)
                }}</mat-error>
              </mat-form-field>
            </div>

            <div class="col-6 pt-3" *ngIf="!formulario.controls.basic.disabled">
              <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                floatLabel="{{ formFieldFloatLabel }}">
                <mat-label class="InputLabelColor">Campo (Básica)</mat-label>
                <input matInput type="number" id="basic" #txtBasic maxlength="20" formControlName="basic" />
                <i matSuffix class="{{ iconEnableField }}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{ hintNumber }}
                </mat-hint>
                <mat-error>{{ hasErrorFormControl(formulario.controls.basic) }}
                </mat-error>
              </mat-form-field>
            </div>

            <div class="col-6 pt-3">
              <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                floatLabel="{{ formFieldFloatLabel }}">
                <mat-label class="InputLabelColor">Híbrido</mat-label>
                <mat-select #txtHibrido formControlName="hibrido" disableCenteringOption>
                  <input matInput type="text" class="form-control filterTxt" placeholder="Pesquisar por..."
                    (keyup)="createFilterHibrido($event.target.value)" />
                  <mat-option *ngFor="let item of listHibrido" [value]="item.name">
                    {{ item.name }}
                  </mat-option>
                </mat-select>
                <i matSuffix class="{{ iconEnableField }}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                <mat-error>
                  {{ hasErrorFormControl(formulario.controls.hibrido) }}
                </mat-error>
              </mat-form-field>
            </div>

            <div class="col-6 pt-3">
              <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                floatLabel="{{ formFieldFloatLabel }}">
                <mat-label class="InputLabelColor">Processo</mat-label>
                <mat-select #txtProcesso formControlName="processo" disableCenteringOption>
                  <input matInput type="text" class="form-control filterTxt" placeholder="Pesquisar por..."
                    (keyup)="createFilterProcesso($event.target.value)" />
                  <mat-option *ngFor="let item of listProcesso" [value]="item.name">
                    {{ item.name | uppercase }}
                  </mat-option>
                </mat-select>
                <i matSuffix class="{{ iconEnableField }}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                <mat-error>
                  {{ hasErrorFormControl(formulario.controls.processo) }}
                </mat-error>
              </mat-form-field>
            </div>

            <div class="col-6 pt-3">
              <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                floatLabel="{{ formFieldFloatLabel }}">
                <mat-label class="InputLabelColor">Lote Origem</mat-label>
                <input matInput id="txtLoteOrigem" #txtLoteOrigem maxlength="40" formControlName="lote_origem" />
                <i matSuffix class="{{ iconEnableField }}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintLoteOrigem}}
                </mat-hint>
                <mat-hint align="end">{{ txtLoteOrigem.value.length }} / 40</mat-hint>
                <mat-error>{{
                  hasErrorFormControl(formulario.controls.lote_origem)
                }}</mat-error>
              </mat-form-field>
            </div>
            <div class="col-6 pt-3">
              <!-- <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Depósito de origem</mat-label>
                                <mat-select #txtDepOrig formControlName="deposito_origem" disableCenteringOption>
                                    <input matInput type="text" class="form-control filterTxt"
                                        placeholder="Pesquisar por..."
                                        (keyup)="createFilterDepositoOrigem($event.target.value)">
                                    <mat-option *ngFor="let item of listDepositoOrigem" [value]="item.name">
                                        {{item.name | uppercase}}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                                <mat-error>
                                    {{hasErrorFormControl(formulario.controls.deposito_origem)}}
                                </mat-error>
                            </mat-form-field> -->
              <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                floatLabel="{{ formFieldFloatLabel }}">
                <mat-label class="InputLabelColor">Depósito de origem</mat-label>
                <input matInput id="txtDepOrig" #txtDepOrig maxlength="40" formControlName="deposito_origem" />
                <i matSuffix class="{{ iconEnableField }}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">
                </mat-hint>
                <mat-hint align="end">{{ txtDepOrig.value.length }} / 40</mat-hint>
                <mat-error>{{
                  hasErrorFormControl(formulario.controls.deposito_origem)
                }}</mat-error>
              </mat-form-field>
            </div>

            <!-- <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">{{hintSafraLabel}}</mat-label>
                                <input matInput id="txtSafra" #txtSafra maxlength="8" formControlName="safra">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintSafra}}
                                </mat-hint>
                                <mat-hint align="end">{{txtSafra.value.length}} / 8</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.safra)}}</mat-error>
                            </mat-form-field>
                        </div> -->

            <div class="col-6 pt-3">
              <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                floatLabel="{{ formFieldFloatLabel }}">
                <mat-label class="InputLabelColor">Umidade do DS (%)</mat-label>
                <input matInput id="txtUmidDs" #txtUmidDs maxlength="10" formControlName="umidade_ds_prc"
                  currencyMask />
                <i matSuffix class="{{ iconEnableField }}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{ hintNumber }}
                </mat-hint>
                <mat-hint align="end">{{ txtUmidDs.value.length }} / 10</mat-hint>
                <mat-error>{{
                  hasErrorFormControl(formulario.controls.umidade_ds_prc)
                }}</mat-error>
              </mat-form-field>
            </div>

            <div class="col-6 pt-3">
              <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                floatLabel="{{ formFieldFloatLabel }}">
                <mat-label class="InputLabelColor">Peneira Topo</mat-label>
                <mat-select #txtPeneiraTopo formControlName="peneira_topo" disableCenteringOption>
                  <input matInput type="text" class="form-control filterTxt" placeholder="Pesquisar por..."
                    (keyup)="createFilterPeneiraTopo($event.target.value)" />
                  <mat-option *ngFor="let item of listPeneiraTopo" [value]="item.name">
                    {{ item.name | uppercase }}
                  </mat-option>
                </mat-select>
                <i matSuffix class="{{ iconEnableField }}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                <mat-error>
                  {{ hasErrorFormControl(formulario.controls.peneira_topo) }}
                </mat-error>
              </mat-form-field>
            </div>

            <div class="col-6 pt-3">
              <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                floatLabel="{{ formFieldFloatLabel }}">
                <mat-label class="InputLabelColor">Peneira Intermediária</mat-label>
                <mat-select #txtPeneiraIntermediaria formControlName="peneira_intermediaria" disableCenteringOption>
                  <input matInput type="text" class="form-control filterTxt" placeholder="Pesquisar por..."
                    (keyup)="createFilterPeneiraIntermediaria($event.target.value)" />
                  <mat-option *ngFor="let item of listPeneiraIntermediaria" [value]="item.name">
                    {{ item.name | uppercase }}
                  </mat-option>
                </mat-select>
                <i matSuffix class="{{ iconEnableField }}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                <mat-error>
                  {{ hasErrorFormControl(formulario.controls.peneira_intermediaria) }}
                </mat-error>
              </mat-form-field>
            </div>




            <div class="col-6 pt-3">
              <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                floatLabel="{{ formFieldFloatLabel }}">
                <mat-label class="InputLabelColor">Peneira Fundo</mat-label>
                <mat-select #txtPeneiraFundo formControlName="peneira_fundo" disableCenteringOption>
                  <input matInput type="text" class="form-control filterTxt" placeholder="Pesquisar por..."
                    (keyup)="createFilterPeneiraFundo($event.target.value)" />
                  <mat-option *ngFor="let item of listPeneiraFundo" [value]="item.name">
                    {{ item.name | uppercase }}
                  </mat-option>
                </mat-select>
                <i matSuffix class="{{ iconEnableField }}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                <mat-error>
                  {{ hasErrorFormControl(formulario.controls.peneira_fundo) }}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-6 pt-3">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Turno</mat-label>
                <mat-select #txtTurno formControlName="turno" disableCenteringOption>
                  <input matInput type="text" class="form-control filterTxt" placeholder="Pesquisar por..."
                    (keyup)="createFilterTurno($event.target.value)">
                  <mat-option *ngFor="let item of listTurno" [value]="item.name">
                    {{item.name | uppercase}}
                  </mat-option>
                </mat-select>
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                <mat-error>
                  {{hasErrorFormControl(formulario.controls.turno)}}
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <!-- <div class="row pt-3">
                        <div class="col-lg-6 col-md-6">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Peneira Fundo</mat-label>
                                <mat-select #txtPeneiraFundo formControlName="peneira_fundo" disableCenteringOption>
                                    <input matInput type="text" class="form-control filterTxt"
                                        placeholder="Pesquisar por..."
                                        (keyup)="createFilterPeneiraFundo($event.target.value)">
                                    <mat-option *ngFor="let item of listPeneiraFundo" [value]="item.name">
                                        {{item.name | uppercase}}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                                <mat-error>
                                    {{hasErrorFormControl(formulario.controls.peneira_fundo)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div> -->
        </mat-card-content>
      </form>
    </mat-card>
  </div>
</div>

<div class="row" *ngIf="isBasica">
  <div class="col-lg col-md col-xs col-xl col-sm w-100">
    <mat-card class="mat-elevation-z8 w-100">
      <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
        <div class="row">
          <div class="col-lg col-md col-xs col-xl col-sm">
            <p class="tituloLeft">{{ step }}</p>
          </div>
          <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
            <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
              *ngIf="!collapseCard"></i>
            <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
              *ngIf="collapseCard"></i>
          </div>
        </div>
        <mat-card-content *ngIf="!collapseCard">
          <div class="row pt-3">
            <div class="col-4 pt-3">
              <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                floatLabel="{{ formFieldFloatLabel }}">
                <mat-label class="InputLabelColor">Site Beneficiamento</mat-label>
                <mat-select #txtMotRepr formControlName="site" disableCenteringOption disabled class="InputBlockColor">
                  <input matInput type="text" class="form-control filterTxt" placeholder="Pesquisar por..."
                    (keyup)="createFilterSite($event.target.value)" />
                  <mat-option *ngFor="let item of listSite" [value]="item.initials">
                    {{ item.initials | uppercase }}
                  </mat-option>
                </mat-select>
                <i matSuffix class="{{ iconDisableField }}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{
                  hintCalc
                }}</mat-hint>
                <mat-error>
                  {{ hasErrorFormControl(formulario.controls.site) }}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-4 pt-3">
              <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                floatLabel="{{ formFieldFloatLabel }}">
                <mat-label class="InputLabelColor">{{
                  hintSafraLabel
                }}</mat-label>
                <input matInput id="txtSafra" #txtSafra maxlength="8" formControlName="safra" class="InputUnblockColor"
                  (blur)="getPc003Data()" />
                <i matSuffix class="{{ iconEnableField }}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{ hintSafra }}
                </mat-hint>
                <mat-hint align="end">{{ txtSafra.value.length }} / 8</mat-hint>
                <mat-error>{{
                  hasErrorFormControl(formulario.controls.safra)
                }}</mat-error>
              </mat-form-field>
            </div>
            <div class="col-4 pt-3" *ngIf="!formulario.controls.basic.disabled">
              <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                floatLabel="{{ formFieldFloatLabel }}">
                <mat-label class="InputLabelColor">Número do Campo</mat-label>
                <input matInput type="number" id="txtNumeroCampo" #txtNumeroCampo maxlength="20"
                  formControlName="numero_campo" appOnlyNumberVirgula (blur)="getPc003Data()" />
                <i matSuffix class="{{ iconEnableField }}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{ hintNumber }}
                </mat-hint>
                <mat-error>{{ hasErrorFormControl(formulario.controls.numero_campo) }}
                </mat-error>
              </mat-form-field>
            </div>

            <!-- Linha 2 -->

            <div class="col-6 pt-3">
              <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                floatLabel="{{ formFieldFloatLabel }}">
                <mat-label class="InputLabelColor">Data</mat-label>
                <input matInput id="txtData" #txtData maxlength="10" mask="d0/M0/0000" formControlName="data" />
                <i matSuffix class="{{ iconEnableField }}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{
                  hintDate
                }}</mat-hint>
                <mat-hint align="end">{{ txtData.value.length }} / 10</mat-hint>
                <mat-error>{{ hasErrorFormControl(formulario.controls.data) }}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-6 pt-3">
              <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                floatLabel="{{ formFieldFloatLabel }}">
                <mat-label class="InputLabelColor">Hora</mat-label>
                <input matInput id="txtHora" #txtHora maxlength="5" mask="Hh:m0" formControlName="hora" />
                <i matSuffix class="{{ iconEnableField }}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{
                  hintHour
                }}</mat-hint>
                <mat-hint align="end">{{ txtHora.value.length }} / 5</mat-hint>
                <mat-error>{{ hasErrorFormControl(formulario.controls.hora) }}
                </mat-error>
              </mat-form-field>
            </div>

            <div class="col-6 pt-3">
              <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                floatLabel="{{ formFieldFloatLabel }}">
                <mat-label class="InputLabelColor">Número Controle</mat-label>
                <input matInput id="txtNumContrl" #txtNumContrl maxlength="10" formControlName="numero_controle"
                  currencyMask [options]="{ thousands: '.', decimal: ',', precision: 0 }" readonly
                  class="InputBlockColor" />
                <i matSuffix class="{{ iconDisableField }}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{ hintControle }}
                </mat-hint>
                <mat-hint align="end">{{ txtNumContrl.value.length }} / 10</mat-hint>
                <mat-error>{{
                  hasErrorFormControl(formulario.controls.numero_controle)
                }}</mat-error>
              </mat-form-field>
            </div>

            <div class="col-6 pt-3">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Híbrido/Linhagem</mat-label>
                <input matInput id="txtHibrido" #txtHibrido maxlength="40" formControlName="hibrido" readonly
                  class="InputBlockColor">
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                <mat-error>
                  {{hasErrorFormControl(formulario.controls.hibrido)}}
                </mat-error>
              </mat-form-field>

            </div>

            <!-- <div class="col-6 pt-3" *ngIf="!formulario.controls.basic.disabled">
              <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                floatLabel="{{ formFieldFloatLabel }}">
                <mat-label class="InputLabelColor">Campo (Básica)</mat-label>
                <input matInput type="number" id="basic" #txtBasic maxlength="20" formControlName="basic" />
                <i matSuffix class="{{ iconEnableField }}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{ hintNumber }}
                </mat-hint>
                <mat-error>{{ hasErrorFormControl(formulario.controls.basic) }}
                </mat-error>
              </mat-form-field>
            </div> -->



            <div class="col-6 pt-3" *ngIf="!formulario.controls.basic.disabled">
              <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                floatLabel="{{ formFieldFloatLabel }}">
                <mat-label class="InputLabelColor">Ajuste #1</mat-label>
                <input matInput type="number" id="txtAjuste_1" #txtAjuste_1 maxlength="20" formControlName="ajuste_1"
                  appOnlyNumberVirgula />
                <i matSuffix class="{{ iconEnableField }}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{ hintNumber }}
                </mat-hint>
                <mat-error>{{ hasErrorFormControl(formulario.controls.basic) }}
                </mat-error>
              </mat-form-field>
            </div>

            <div class="col-6 pt-3" *ngIf="!formulario.controls.basic.disabled">
              <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                floatLabel="{{ formFieldFloatLabel }}">
                <mat-label class="InputLabelColor">Ajuste #2</mat-label>
                <input matInput type="number" id="txtAjuste_2" #txtAjuste_1 maxlength="20" formControlName="ajuste_2"
                  appOnlyNumberVirgula />
                <i matSuffix class="{{ iconEnableField }}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{ hintNumber }}
                </mat-hint>
                <mat-error>{{ hasErrorFormControl(formulario.controls.basic) }}
                </mat-error>
              </mat-form-field>
            </div>

            <div class="col-6 pt-3" *ngIf="!formulario.controls.basic.disabled">
              <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                floatLabel="{{ formFieldFloatLabel }}">
                <mat-label class="InputLabelColor">Ajuste #3</mat-label>
                <input matInput type="number" id="txtAjuste_3" #txtAjuste_3 maxlength="20" formControlName="ajuste_3"
                  appOnlyNumberVirgula />
                <i matSuffix class="{{ iconEnableField }}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{ hintNumber }}
                </mat-hint>
                <mat-error>{{ hasErrorFormControl(formulario.controls.basic) }}
                </mat-error>
              </mat-form-field>
            </div>

            <div class="col-6 pt-3" *ngIf="!formulario.controls.basic.disabled">
              <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                floatLabel="{{ formFieldFloatLabel }}">
                <mat-label class="InputLabelColor">Ajuste #4</mat-label>
                <input matInput type="number" id="txtAjuste_4" #txtAjuste_4 maxlength="20" formControlName="ajuste_4"
                  appOnlyNumberVirgula />
                <i matSuffix class="{{ iconEnableField }}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{ hintNumber }}
                </mat-hint>
                <mat-error>{{ hasErrorFormControl(formulario.controls.basic) }}
                </mat-error>
              </mat-form-field>
            </div>

            <div class="col-6 pt-3" *ngIf="!formulario.controls.basic.disabled">
              <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                floatLabel="{{ formFieldFloatLabel }}">
                <mat-label class="InputLabelColor">Ajuste #5</mat-label>
                <input matInput type="number" id="txtAjuste_5" #txtAjuste_5 maxlength="20" formControlName="ajuste_5"
                  appOnlyNumberVirgula />
                <i matSuffix class="{{ iconEnableField }}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{ hintNumber }}
                </mat-hint>
                <mat-error>{{ hasErrorFormControl(formulario.controls.basic) }}
                </mat-error>
              </mat-form-field>
            </div>

            <div class="col-6 pt-3" *ngIf="!formulario.controls.basic.disabled">
              <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                floatLabel="{{ formFieldFloatLabel }}">
                <mat-label class="InputLabelColor">Ajuste #6</mat-label>
                <input matInput type="number" id="txtAjuste_6" #txtAjuste_6 maxlength="20" formControlName="ajuste_6"
                  appOnlyNumberVirgula />
                <i matSuffix class="{{ iconEnableField }}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{ hintNumber }}
                </mat-hint>
                <mat-error>{{ hasErrorFormControl(formulario.controls.basic) }}
                </mat-error>
              </mat-form-field>
            </div>


            <!-- <div class="col-6 pt-3">
              <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                floatLabel="{{ formFieldFloatLabel }}">
                <mat-label class="InputLabelColor">Processo</mat-label>
                <mat-select #txtProcesso formControlName="processo" disableCenteringOption>
                  <input matInput type="text" class="form-control filterTxt" placeholder="Pesquisar por..."
                    (keyup)="createFilterProcesso($event.target.value)" />
                  <mat-option *ngFor="let item of listProcesso" [value]="item.name">
                    {{ item.name | uppercase }}
                  </mat-option>
                </mat-select>
                <i matSuffix class="{{ iconEnableField }}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                <mat-error>
                  {{ hasErrorFormControl(formulario.controls.processo) }}
                </mat-error>
              </mat-form-field>
            </div> -->

            <div class="col-6 pt-3">
              <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                floatLabel="{{ formFieldFloatLabel }}">
                <mat-label class="InputLabelColor">Lote Origem</mat-label>
                <input matInput id="txtLoteOrigem" #txtLoteOrigem maxlength="40" formControlName="lote_origem" />
                <i matSuffix class="{{ iconEnableField }}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintLoteOrigem}}
                </mat-hint>
                <mat-hint align="end">{{ txtLoteOrigem.value.length }} / 40</mat-hint>
                <mat-error>{{
                  hasErrorFormControl(formulario.controls.lote_origem)
                }}</mat-error>
              </mat-form-field>
            </div>
            <!-- <div class="col-6 pt-3"> -->
            <!-- <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Depósito de origem</mat-label>
                                <mat-select #txtDepOrig formControlName="deposito_origem" disableCenteringOption>
                                    <input matInput type="text" class="form-control filterTxt"
                                        placeholder="Pesquisar por..."
                                        (keyup)="createFilterDepositoOrigem($event.target.value)">
                                    <mat-option *ngFor="let item of listDepositoOrigem" [value]="item.name">
                                        {{item.name | uppercase}}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                                <mat-error>
                                    {{hasErrorFormControl(formulario.controls.deposito_origem)}}
                                </mat-error>
                            </mat-form-field> -->
            <!-- <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                floatLabel="{{ formFieldFloatLabel }}">
                <mat-label class="InputLabelColor">Depósito de origem</mat-label>
                <input matInput id="txtDepOrig" #txtDepOrig maxlength="40" formControlName="deposito_origem" />
                <i matSuffix class="{{ iconEnableField }}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">
                </mat-hint>
                <mat-hint align="end">{{ txtDepOrig.value.length }} / 40</mat-hint>
                <mat-error>{{
                  hasErrorFormControl(formulario.controls.deposito_origem)
                }}</mat-error>
              </mat-form-field> -->
            <!-- </div> -->

            <!-- <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">{{hintSafraLabel}}</mat-label>
                                <input matInput id="txtSafra" #txtSafra maxlength="8" formControlName="safra">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintSafra}}
                                </mat-hint>
                                <mat-hint align="end">{{txtSafra.value.length}} / 8</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.safra)}}</mat-error>
                            </mat-form-field>
                        </div> -->

            <div class="col-6 pt-3">
              <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                floatLabel="{{ formFieldFloatLabel }}">
                <mat-label class="InputLabelColor">Umidade do DS (%)</mat-label>
                <input matInput id="txtUmidDs" #txtUmidDs maxlength="10" formControlName="umidade_ds_prc"
                  currencyMask />
                <i matSuffix class="{{ iconEnableField }}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{ hintNumber }}
                </mat-hint>
                <mat-hint align="end">{{ txtUmidDs.value.length }} / 10</mat-hint>
                <mat-error>{{
                  hasErrorFormControl(formulario.controls.umidade_ds_prc)
                }}</mat-error>
              </mat-form-field>
            </div>

            <div class="col-6 pt-3">
              <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                floatLabel="{{ formFieldFloatLabel }}">
                <mat-label class="InputLabelColor">Peneira Topo</mat-label>
                <mat-select #txtPeneiraTopo formControlName="peneira_topo" disableCenteringOption>
                  <input matInput type="text" class="form-control filterTxt" placeholder="Pesquisar por..."
                    (keyup)="createFilterPeneiraTopo($event.target.value)" />
                  <mat-option *ngFor="let item of listPeneiraTopo" [value]="item.name">
                    {{ item.name | uppercase }}
                  </mat-option>
                </mat-select>
                <i matSuffix class="{{ iconEnableField }}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                <mat-error>
                  {{ hasErrorFormControl(formulario.controls.peneira_topo) }}
                </mat-error>
              </mat-form-field>
            </div>

            <!-- <div class="col-6 pt-3">
              <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                floatLabel="{{ formFieldFloatLabel }}">
                <mat-label class="InputLabelColor">Peneira Intermediária</mat-label>
                <mat-select #txtPeneiraIntermediaria formControlName="peneira_intermediaria" disableCenteringOption>
                  <input matInput type="text" class="form-control filterTxt" placeholder="Pesquisar por..."
                    (keyup)="createFilterPeneiraIntermediaria($event.target.value)" />
                  <mat-option *ngFor="let item of listPeneiraIntermediaria" [value]="item.name">
                    {{ item.name | uppercase }}
                  </mat-option>
                </mat-select>
                <i matSuffix class="{{ iconEnableField }}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                <mat-error>
                  {{ hasErrorFormControl(formulario.controls.peneira_intermediaria) }}
                </mat-error>
              </mat-form-field>
            </div> -->




            <div class="col-6 pt-3">
              <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                floatLabel="{{ formFieldFloatLabel }}">
                <mat-label class="InputLabelColor">Peneira Fundo</mat-label>
                <mat-select #txtPeneiraFundo formControlName="peneira_fundo" disableCenteringOption>
                  <input matInput type="text" class="form-control filterTxt" placeholder="Pesquisar por..."
                    (keyup)="createFilterPeneiraFundo($event.target.value)" />
                  <mat-option *ngFor="let item of listPeneiraFundo" [value]="item.name">
                    {{ item.name | uppercase }}
                  </mat-option>
                </mat-select>
                <i matSuffix class="{{ iconEnableField }}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                <mat-error>
                  {{ hasErrorFormControl(formulario.controls.peneira_fundo) }}
                </mat-error>
              </mat-form-field>
            </div>
          </div>



          <!-- <div class="row pt-3">
                        <div class="col-lg-6 col-md-6">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Peneira Fundo</mat-label>
                                <mat-select #txtPeneiraFundo formControlName="peneira_fundo" disableCenteringOption>
                                    <input matInput type="text" class="form-control filterTxt"
                                        placeholder="Pesquisar por..."
                                        (keyup)="createFilterPeneiraFundo($event.target.value)">
                                    <mat-option *ngFor="let item of listPeneiraFundo" [value]="item.name">
                                        {{item.name | uppercase}}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                                <mat-error>
                                    {{hasErrorFormControl(formulario.controls.peneira_fundo)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div> -->
        </mat-card-content>
      </form>
    </mat-card>
  </div>
</div>